import { $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  $$('[data-au-form-error-title]').forEach((titleEl) => {
    const formError = titleEl.closest('[data-au-form-error]');
    if (!formError) return;

    formError.addEventListener('click', (e) => {
      const link = e.target.closest('a');
      if (!link) return;

      const titleText = removeAccentMarkAndUppercase(titleEl.innerText || '');
      const clickText = removeAccentMarkAndUppercase(link.innerText || '');

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickEnlace',
        item_id: `${titleText}_${clickText}`,
      });
    });
  });
}

export default { init };
